




















import { Button } from 'element-ui'
import { Vue, Prop, Component } from 'vue-property-decorator'

import Booking from '@/models/booking'

import EventBus from '@/event-bus'

@Component({
  components: {
    [Button.name]: Button,
  },
})
export default class BankPaymentBody extends Vue {
  @Prop() booking!: Booking
  @Prop() paymentCode!: string
  @Prop() bankTransferTemplate!: string

  created() {
    EventBus.$emit('on-bank-payment-open')
  }
}
